import {put} from "../../../../shared/SagaService";
import actions from "../../actions";
import {
    updateStore as updateStoreForTransaction,
} from "../../../Transaction/initTransaction/helper/updateStore";
import TransactionActions from 'bukku/redux/Transaction/actions';

// main function
export function* updateStore(instruction, transaction) {
    yield put(
        TransactionActions.transactionResetState(),
    );

    yield put(
        actions.changeSendEmail(instruction.send_email),
    );

    yield put(
        actions.initInstructionSuccess(instruction),
    );

    yield updateStoreForTransaction(transaction, instruction.transaction_type, null);
}
